import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Mail } from 'lucide-react';
import api from '../utils/api';
import toast from 'react-hot-toast';
import { useLoader } from '../components/shared/LoaderContext';

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const { showLoader, hideLoader } = useLoader();

  const handleSubmit = async (e) => {
    e.preventDefault();
    const interval = showLoader('Sending reset email...');
    try {
      await api.post('/auth/forgot-password', { email });
      hideLoader(interval);
      setSent(true);
      toast.success('Check your email for reset instructions');
    } catch {
      hideLoader(interval);
      toast.error('Something went wrong');
    }
  };

  return (
    <div style={{
      minHeight: '100vh', background: 'linear-gradient(135deg, #0f2440 0%, #1a3a5c 50%, #2563a8 100%)',
      display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20
    }}>
      <div style={{ width: '100%', maxWidth: 420 }}>
        <div style={{ textAlign: 'center', marginBottom: 28, color: 'white' }}>
          <div style={{
            width: 64, height: 64, borderRadius: '50%',
            background: 'rgba(200,151,58,0.2)', border: '2px solid var(--accent)',
            display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 14px'
          }}>
            <Mail size={26} style={{ color: 'var(--accent)' }} />
          </div>
          <h1 style={{ fontSize: 24, fontFamily: "'Playfair Display', serif" }}>Forgot Password</h1>
        </div>

        <div className="card" style={{ padding: 32 }}>
          {sent ? (
            <div style={{ textAlign: 'center' }}>
              <div style={{ fontSize: 40, marginBottom: 12 }}>📧</div>
              <h3 style={{ color: 'var(--primary)', marginBottom: 8 }}>Email Sent</h3>
              <p style={{ color: 'var(--text-muted)', fontSize: 14 }}>
                If that email is registered, you'll receive a temporary password shortly.
              </p>
              <Link to="/login" className="btn btn-primary" style={{ marginTop: 20, display: 'inline-flex' }}>
                Back to Login
              </Link>
            </div>
          ) : (
            <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 18 }}>
              <p style={{ color: 'var(--text-muted)', fontSize: 14 }}>
                Enter your registered email address and we'll send you a temporary password.
              </p>
              <div className="form-group">
                <label className="form-label">Email Address</label>
                <input type="email" className="form-input" value={email}
                  onChange={(e) => setEmail(e.target.value)} required placeholder="your@email.com" />
              </div>
              <button type="submit" className="btn btn-primary"
                style={{ width: '100%', justifyContent: 'center', padding: '12px' }}>
                Send Reset Email
              </button>
              <div style={{ textAlign: 'center', fontSize: 14 }}>
                <Link to="/login" style={{ color: 'var(--primary-light)', textDecoration: 'none' }}>← Back to Login</Link>
              </div>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
